import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      --dustin-side-column-width: calc(180rem / var(--default-rem-px-count));
      --dustin-column-gap: calc(32rem / var(--default-rem-px-count));
      --dustin-section-gap: calc(60rem / var(--default-rem-px-count));
      --dustin-right-inset: 0;
    }

    .dustin-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    .dustin-body {
      grid-column: 2 / 8;
      grid-row: 2;
      display: flex;
      flex-direction: column;
      gap: calc(24rem / var(--default-rem-px-count));
      color: var(--block-text-color, #222);
    }

    .text-sections {
      display: flex;
      flex-direction: column;
      gap: var(--dustin-section-gap);
    }

    /* Text sections (right column on tablet+, stacked on mobile) */
    .text-section {
      display: flex;
      flex-direction: column;
      gap: calc(16rem / var(--default-rem-px-count));
    }

    /* Heading is an h2; the shared type defaults set its scale. */
    .text-section-heading {
      color: var(--block-text-color, #222);
    }

    .text-section-body {
      display: flex;
      flex-direction: column;
      gap: calc(20rem / var(--default-rem-px-count));
    }

    /* Desktop/tablet sidebar */
    .project-details-desktop {
      display: none;
    }

    /* Mobile collapsible sidebar (Walter barrel pattern) */
    .project-details-mobile.closed {
      overflow: hidden;
    }

    .project-details-mobile.closed .project-details-content {
      display: none;
    }

    .project-details-mobile.expanded .project-details-content {
      padding-top: calc(24rem / var(--default-rem-px-count));
      padding-bottom: calc(8rem / var(--default-rem-px-count));
      display: flex;
      flex-direction: column;
    }

    .project-details-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      min-height: calc(60rem / var(--default-rem-px-count));
      border-top: 2px solid #222;
      cursor: pointer;
    }

    .project-details-heading {
      display: flex;
      align-items: center;
      font-weight: var(--fw-medium);
      font-size: var(--fs-label-small);
      line-height: var(--lh-label-small);
      letter-spacing: var(--ls-label-small);
    }

    .project-details-icon {
      display: flex;
      justify-content: right;
      min-height: 2em;
      min-width: 2em;
    }

    /* Stacked rows sit 30px apart; a label sits 16px above its value to
       match the material-details-block row-header/row-body spacing. */
    .project-details-content,
    .project-details-desktop {
      gap: calc(30rem / var(--default-rem-px-count));
    }

    .project-detail-row {
      display: flex;
      flex-direction: column;
      gap: calc(2rem / var(--default-rem-px-count));
    }

    .project-detail-label {
      font-weight: var(--fw-medium);
      font-size: var(--fs-label-small);
      line-height: var(--lh-label-small);
      letter-spacing: var(--ls-label-small);
      margin: 0;
      color: var(--block-text-color, #222);
    }

    .project-detail-value {
      font-size: var(--fs-body-small);
      line-height: var(--lh-body-small);
      letter-spacing: var(--ls-body-small);
      color: var(--block-text-color, #222);
    }

    /* Match both <p> (legacy editor input) and <div> (Trix output). */
    .project-detail-value p,
    .project-detail-value div {
      margin: 0;
      font-size: inherit;
      line-height: inherit;
      letter-spacing: inherit;
    }

    /* Tablet+ */
    @media (min-width: 600px) {
      :host {
        --dustin-side-column-width: calc(180rem / var(--default-rem-px-count));
        --dustin-column-gap: calc(32rem / var(--default-rem-px-count));
        --dustin-section-gap: calc(80rem / var(--default-rem-px-count));
        --dustin-right-inset: 0;
      }

      .dustin-body {
        grid-column: 2 / 14;
        display: grid;
        grid-template-columns:
          var(--dustin-side-column-width)
          1fr;
        column-gap: var(--dustin-column-gap);
        padding-right: var(--dustin-right-inset);
      }

      .project-details {
        grid-column: 1;
        grid-row: 1;
      }

      .text-sections {
        grid-column: 2;
        grid-row: 1;
      }

      /* Hide the mobile barrel and use the plain sidebar layout */
      .project-details-mobile {
        display: none;
      }

      .project-details-desktop {
        display: flex;
        flex-direction: column;
      }

      /* When the sidebar content is hidden we keep the grid column so
         the right column does not shift horizontally. */
      .dustin-body.project-details-hidden .project-details {
        visibility: hidden;
      }
    }

    /* Desktop */
    @media (min-width: 1024px) {
      :host {
        --dustin-side-column-width: calc(318rem / var(--default-rem-px-count));
        --dustin-column-gap: calc(32rem / var(--default-rem-px-count));
        --dustin-section-gap: calc(100rem / var(--default-rem-px-count));
        --dustin-right-inset: calc(233rem / var(--default-rem-px-count));
      }

      .text-sections {
        max-width: calc(785rem / var(--default-rem-px-count));
      }

      .text-section {
        flex-direction: row;
        align-items: baseline;
        gap: calc(34rem / var(--default-rem-px-count));
      }

      .text-section-heading {
        flex: 1 0 0;
        min-width: 0;
        max-width: calc(201rem / var(--default-rem-px-count));
      }

      .text-section-body {
        flex: 1 0 0;
        min-width: 0;
      }
    }
  `,
];
